import type { Organization } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/organization_pb";
import type { AdminOrganizationType } from "components/Admin/types";
import type IOrg from "models/Organization.model";

export function mapOrganization(org: Organization): IOrg {
  return {
    id: org.organizationId,
    name: org.displayName,
    slug: org.username,
    defaultWorkspaceGroupId: "",
    labels: Object.keys(org.labels).length > 0 ? org.labels : null,
    programId: org.program?.programId || null,
    nca_id: org.ncaId || null,
    ngc_org_id: org.ngcOrgId || null,
    ngc_enablements: org.ngcEnablements.map((enablement) => ({
      productName: enablement.productName,
      product_name: enablement.productName,
    })),
  };
}

export function mapAdminOrganization(
  organization: Organization,
): AdminOrganizationType {
  return {
    id: organization.organizationId,
    created_at: organization.createTime?.toDate().toISOString() ?? "",
    updated_at: organization.updateTime?.toDate().toISOString() ?? "",
    deleted_at: null,
    Name: organization.displayName,
    Slug: organization.username,
    DefaultWorkspaceGroupID: "",
    ExternalPaymentID: "",
    IsBlocked: false,
    WarnEmailsSent: 0,
    NCAID: organization.ncaId,
    NGCOrgID: organization.ngcOrgId,
    Labels: Object.keys(organization.labels).length
      ? organization.labels
      : null,
    ProgramID: organization.program?.programId || undefined,
    ReservedInstancePools: organization.reservedInstancePools,
  };
}
